export default __webpack_public_path__ + "static/media/View-documentation.7d4ea22f.md";